import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import './IntegrationsWelcomeModal.scss';

const IntegrationsWelcomeModal = memo(
  ({ open, onClose, title = '', contentComponent }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth='md'
        className='welcome-modal__dialog'
      >
        <div className='welcome-modal__header'>
          <span className='welcome-modal__title'>{title}</span>
          <span className='welcome-modal__close-button' onClick={onClose}>
            &#x2715;
          </span>
        </div>

        {contentComponent}
      </Dialog>
    );
  }
);

IntegrationsWelcomeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  contentComponent: PropTypes.node
};

IntegrationsWelcomeModal.displayName = 'IntegrationsWelcomeModal';

export default IntegrationsWelcomeModal;
